fragment sentenceDetails on SentenceType {
  id
  sefariaId
  isResponsive
  text
}
